const NotFound = () => {
	return (
		<div>
			<h1>404 - Not Found</h1>
			<p>The page you are looking for does not exist.</p>
			<a href="/">Go back to Home</a>
		</div>
	);
};

export default NotFound;
